module.exports = __webpack_public_path__ + "media/images/es/hp_curtain-aceb60c03a1dba0d1971b01371dba3d7.png";